/**
 * Obálka nad pdfjs-dist pro viewer výkresů (Blok C). PDF se vykresluje na
 * canvas na klientu; DWG se nerenderuje vůbec (jen ke stažení, f2).
 *
 * pdfjs se načítá DYNAMICKY až při prvním otevření výkresu — worker přes
 * Vite `?url` (samostatný chunk, správná cesta i po buildu), hlavní bundle
 * webu zůstává bez ~1 MB knihovny.
 */

export interface PdfDokument {
  pocetStranek: number;
  /**
   * Vykreslí stránku (1-based) do canvasu v základním měřítku — zoom/pan řeší
   * viewer CSS transformací (žádné překreslování při gestu). Vrací rozměr
   * canvasu v px (pro overlay pinů).
   */
  vykresliStranku(
    cislo: number,
    canvas: HTMLCanvasElement,
  ): Promise<{ sirka: number; vyska: number }>;
  znic(): void;
}

/** Základní měřítko renderu — 1.5× je čitelné i po přiblížení CSS zoomem. */
const MERITKO = 1.5;

export async function nactiPdf(url: string): Promise<PdfDokument> {
  const [pdfjs, worker] = await Promise.all([
    import('pdfjs-dist'),
    import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
  ]);
  pdfjs.GlobalWorkerOptions.workerSrc = worker.default;

  // Session cookie musí jít i do requestu na soubor (API je za přihlášením).
  const uloha = pdfjs.getDocument({ url, withCredentials: true });
  const doc = await uloha.promise;

  return {
    pocetStranek: doc.numPages,
    async vykresliStranku(cislo, canvas) {
      const stranka = await doc.getPage(cislo);
      const viewport = stranka.getViewport({ scale: MERITKO });
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      // jsdom v testech context neumí — mock lib/pdf.ts render přeskakuje.
      if (canvas.getContext('2d')) await stranka.render({ canvas, viewport }).promise;
      return { sirka: viewport.width, vyska: viewport.height };
    },
    znic: () => void uloha.destroy(),
  };
}
